import { ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Router } from '@angular/router';

import { environment } from 'environments/environment';

import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { AuthenticationGuard } from 'app/services/authentication-guard.service';

import { UpdatePersonComponent } from './updateperson/update-person.component';

import { formatDisplayDate } from 'app/shared/utils/date-format.util';
import { Person } from 'app/shared/models/person.model';
import { UploadLogoComponent } from 'app/shared/components/uploadlogo/upload-logo.component';

import { PersonHeaderService } from './person-header.service';
import { ArchivalConfirmComponent } from 'app/admin/archival/archivalconfirm/archival-confirm.component';

/**
 * Main component for person header.
 */
@Component({
  selector: 'app-person-header',
  templateUrl: './person-header.component.html'
})

export class PersonHeaderComponent implements OnInit {
  personDetails: Person;
  dialogRef: MdDialogRef<any>;
  selectedIndex = 0;
  personLogo: string;
  isAdmin = false;

  // Constructor method
  constructor(
    private personHeaderService: PersonHeaderService,
    private viewContainerRef: ViewContainerRef,
    private dialog: MdDialog,
    private snackBarService: SnackBarService,
    private authenticationGuard: AuthenticationGuard,
    private router: Router) {
    this.isAdmin = this.authenticationGuard.isAdminUser();
  }

  ngOnInit() {
    this.personDetails = new Person();
    this.personHeaderService.onPersonDetailsEvent().subscribe(
      personDetails => {
        this.personDetails = personDetails;
        this.personLogo = this.personDetails.logo;
      }
    );
  }

  openUpdatePersonDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(UpdatePersonComponent, config);
    this.dialogRef.componentInstance.personDetails = this.personDetails;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.personDetails = result;
      }
    });
  }

  /**
   * Admin-only archival of the person entity currently being viewed. Reuses the
   * same archival confirmation dialog as the admin archival management screen,
   * so the backend flow (archive to JSON, remove entity + dependencies,
   * unregister from continuous screening) stays identical.
   */
  openArchivalConfirmDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(ArchivalConfirmComponent, config);
    this.dialogRef.componentInstance.argMultipleArchival = false;
    this.dialogRef.componentInstance.argEntityId = this.personDetails.entityId;
    this.dialogRef.componentInstance.argDeleteClientOnly = false;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  formatDate(dateField) {
    return formatDisplayDate(dateField);
  }

  callSnackBarService(response: any, successMsg: string, failureMsg: string) {
    this.snackBarService.showStatus(response, successMsg, failureMsg);
  }

  updateEntityLogo() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(UploadLogoComponent, config);
    this.dialogRef.componentInstance.entityId = this.personDetails.entityId;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.updateLogo(result);
      }
    });
  }

  updateLogo(result) {
    this.personLogo = result;
  }
}



// WEBPACK FOOTER //
// ./src/app/person/header/person-header.component.ts